var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9.5A28.5 28.5 0 1066.5 38 28.54 28.54 0 0038 9.5zM38 63a25 25 0 1125-25 25.08 25.08 0 01-25 25zm-1.91-45h3.82v21.91H18v-3.82h18.09V18z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Time.d86e4fe6.svg";
export { SvgBzTime as ReactComponent };